export * from './Heading.theme';
export * from './Heading';
